import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Row, Col, Card, Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import bsCustomFileInput from "bs-custom-file-input";
import Loader from "react-loader-spinner";
import { validationSchema } from "../../utils/validationSchema";
import { postEnrolled } from "../../services/enrolled.service";
import { promiseCompressor } from "../../utils/promiseCompressor";
import "../../styles/styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
registerLocale("es", es);

export const FormInscription = () => {
	const [startDate, setStartDate] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const { register, handleSubmit, errors } = useForm({
		mode: "onChange",
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		bsCustomFileInput.init();
	}, []);
	const onSubmit = async (data) => {
		data.birthday = dayjs(startDate).format("YYYY-MM-DD");
		data.fechaInsc = dayjs(new Date()).format("YYYY-MM-DD");

		if (!data.veracidad) {
			return Swal.fire(
				"Error",
				"Debe aceptar la veracidad de la información",
				"error"
			);
		}

		if (
			!data.imgdnifrente[0] ||
			!data.imgdnidorso[0] ||
			!data.imgdnitutorfrente[0] ||
			!data.imgdnitutordorso[0]
		) {
			return Swal.fire(
				"Error",
				"Debe enviar TODAS las imágenes requeridas",
				"error"
			);
		}

		setLoading(true);

		let formData = new FormData();

		let compressor1 = await promiseCompressor(data.imgdnifrente[0]);
		let compressor2 = await promiseCompressor(data.imgdnidorso[0]);
		let compressor3 = await promiseCompressor(data.imgdnitutorfrente[0]);
		let compressor4 = await promiseCompressor(data.imgdnitutordorso[0]);

		formData.append("imgdnifrente", compressor1, compressor1.name);
		formData.append("imgdnidorso", compressor2, compressor2.name);
		formData.append("imgdnitutorfrente", compressor3, compressor3.name);
		formData.append("imgdnitutordorso", compressor4, compressor4.name);
		formData.append("values", JSON.stringify(data));

		const res = await postEnrolled(formData);
		if (res.status === 200) {
			setLoading(false);
			Swal.fire({
				title: "Exito",
				text: "Se registro correctamente!",
				icon: "success",
				willClose: () => window.location.reload(),
			});
		} else {
			setLoading(false);
			if (res.response?.data?.mensaje && typeof res.response.data.mensaje === "string") {
				Swal.fire({
					title: "Ya esta inscripto!",
					text: `${res.response.data.mensaje}`,
					icon: "error",
					willClose: () => window.location.reload(),
				});
			} else {
				Swal.fire({
					title: "Error",
					text: "Hubo un error al registrarse. Intente nuevamente",
					icon: "error",
					willClose: () => window.location.reload(),
				});
			}
		}
		setLoading(false);
	};

	function uploadFile(e) {
		if (e.target.name === "imgdnifrente") {
			document.getElementById("imgdnifrente-name").innerHTML =
				e.target.files[0].name;
		} else if (e.target.name === "imgdnidorso") {
			document.getElementById("imgdnidorso-name").innerHTML =
				e.target.files[0].name;
		} else if (e.target.name === "imgdnitutorfrente") {
			document.getElementById("imgdnitutorfrente-name").innerHTML =
				e.target.files[0].name;
		} else {
			document.getElementById("imgdnitutordorso-name").innerHTML =
				e.target.files[0].name;
		}
	}

	if (loading) {
		return (
			<div
				className="d-flex justify-content-center align-items-center flex-column mt-5"
				style={{ minHeight: "60vh" }}
			>
				<Loader type="TailSpin" color="#00BFFF" height={200} width={200} />
				<p className="lead mt-5">Enviando...</p>
			</div>
		);
	}
	return (
		<div className="container mt-5">
			<Form style={{ fontWeight: 600 }} onSubmit={handleSubmit(onSubmit)}>
				<Card className="shadow mb-5 bg-white rounded">
					<Card.Header className="text-center">Datos del niño/a</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2">
								<Col>
									<Form.Label>Nombre</Form.Label>
									<Form.Control
										name="name"
										ref={register}
										isInvalid={!!errors.name}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.name?.message}
									</Form.Control.Feedback>
								</Col>
								<Col>
									<Form.Label>Apellido</Form.Label>
									<Form.Control
										name="lastname"
										ref={register}
										isInvalid={!!errors.lastname}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.lastname?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col>
									<Form.Label>Edad</Form.Label>
									<Form.Control
										type="number"
										name="age"
										ref={register}
										isInvalid={!!errors.age}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.age?.message}
									</Form.Control.Feedback>
								</Col>
								<Col>
									<Form.Label>DNI</Form.Label>
									<Form.Control
										name="dni"
										ref={register}
										isInvalid={!!errors.dni}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.dni?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col md="6" className="mb-sm-2">
									<Form.Label>Dirección</Form.Label>
									<Form.Control
										name="address"
										ref={register}
										isInvalid={!!errors.address}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.address?.message}
									</Form.Control.Feedback>
								</Col>
								<Col className="d-flex flex-column">
									<Form.Label>Fecha de nacimiento</Form.Label>
									<DatePicker
										locale="es"
										className="form-control"
										selected={startDate}
										onChange={(date) => setStartDate(date)}
										dateFormat="dd/MM/yyyy"
										peekNextMonth
										showMonthDropdown
										showYearDropdown
										dropdownMode="select"
									/>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col>
									<Form.Label>Desarrollo del evento</Form.Label>
									<Form.Control as="select" name="event" ref={register}>
										<option>ABRIL</option>
										<option>MAYO</option>
										<option>JUNIO</option>
										<option>JULIO</option>
										<option>AGOSTO</option>
										<option>SEPTIEMBRE</option>
										<option>OCTUBRE</option>
										<option>NOVIEMBRE</option>
										<option>DICIEMBRE</option>
									</Form.Control>
								</Col>
							</Row>
						</Form.Group>
						<Form.Group>
							<Form.Label>Imagen DNI</Form.Label>
							<Row className="mb-3">
								<Col xs="12" md="6" className="mb-sm-3 d-flex flex-column">
									{/* <Form.File
										id='imgdnifrente'
										name='imgdnifrente'
										label='IMÁGEN DNI FRENTE'
										custom
										data-browse='Buscar'
										accept='.jpg,.png'
										ref={register}
									/> */}
									<div className="d-flex align-items-center">
										<Form.Label className="mr-3 mb-0">Frente</Form.Label>
										<div className="file-upload">
											<input
												className="file"
												type="file"
												onChange={uploadFile}
												id="imgdnifrente"
												name="imgdnifrente"
												custom
												data-browse="Buscar"
												accept=".jpg,.png"
												ref={register}
											/>
											<FontAwesomeIcon icon={faUpload} />
											<label className="ml-2 mb-0">Cargar</label>
										</div>
									</div>
									<span
										id="imgdnifrente-name"
										className="mt-2"
										style={{ color: "#92ADC5" }}
									></span>
								</Col>
								<Col className="mb-sm-3 d-flex flex-column">
									{/* <Form.File
										id='imgdnidorso'
										name='imgdnidorso'
										label='IMÁGEN DNI DORSO'
										custom
										data-browse='Buscar'
										accept='.jpg,.png'
										ref={register}
									/> */}
									<div className="d-flex align-items-center">
										<Form.Label className="mr-3 mb-0">Dorso</Form.Label>
										<div className="file-upload">
											<input
												className="file"
												type="file"
												onChange={uploadFile}
												id="imgdnidorso"
												name="imgdnidorso"
												custom
												data-browse="Buscar"
												accept=".jpg,.png"
												ref={register}
											/>
											<FontAwesomeIcon icon={faUpload} />
											<label className="ml-2 mb-0">Cargar</label>
										</div>
									</div>
									<span
										id="imgdnidorso-name"
										className="mt-2"
										style={{ color: "#92ADC5" }}
									></span>
								</Col>
							</Row>
						</Form.Group>
					</Card.Body>
				</Card>
				<Card className="shadow bg-white rounded">
					<Card.Header className="text-center">
						Datos del adulto responsable
					</Card.Header>
					<Card.Body>
						<Form.Group>
							<Row className="mb-2">
								<Col>
									<Form.Label>Nombre</Form.Label>
									<Form.Control
										name="nametutor"
										ref={register}
										isInvalid={!!errors.nametutor}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.nametutor?.message}
									</Form.Control.Feedback>
								</Col>
								<Col>
									<Form.Label>Apellido</Form.Label>
									<Form.Control
										name="lastnametutor"
										ref={register}
										isInvalid={!!errors.lastnametutor}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.lastnametutor?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col>
									<Form.Label>DNI</Form.Label>
									<Form.Control
										name="dnitutor"
										ref={register}
										isInvalid={!!errors.dnitutor}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.dnitutor?.message}
									</Form.Control.Feedback>
								</Col>
								<Col>
									<Form.Label>Dirección</Form.Label>
									<Form.Control
										name="addresstutor"
										ref={register}
										isInvalid={errors.addresstutor}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.addresstutor?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col>
									<Form.Label>Teléfono</Form.Label>
									<Form.Control
										name="phone"
										ref={register}
										isInvalid={!!errors.phone}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.phone?.message}
									</Form.Control.Feedback>
								</Col>
								<Col>
									<Form.Label>Email</Form.Label>
									<Form.Control
										name="email"
										ref={register}
										isInvalid={errors.email}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.email?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
							<Row className="mb-2">
								<Col xs="12" md="6" className="mb-sm-3">
									<Form.Label>Parentesco</Form.Label>
									<Form.Control
										name="parentesco"
										ref={register}
										isInvalid={!!errors.parentesco}
									/>
									<Form.Control.Feedback type="invalid">
										{errors.parentesco?.message}
									</Form.Control.Feedback>
								</Col>
							</Row>
						</Form.Group>
						<Form.Group>
							<Form.Label>Imagen DNI Tutor</Form.Label>
							<Row>
								<Col xs="12" md="6" className="mb-sm-3 d-flex flex-column">
									{/* <Form.File
										name='imgdnitutorfrente'
										id='imgdnitutorfrente'
										label='IMÁGEN DNI TUTOR FRENTE'
										custom
										data-browse='Buscar'
										accept='.jpg,.png'
										ref={register}
									/> */}
									<div className="d-flex align-items-center">
										<Form.Label className="mr-3 mb-0">Frente</Form.Label>
										<div className="file-upload">
											<input
												className="file"
												type="file"
												onChange={uploadFile}
												id="imgdnitutorfrente"
												name="imgdnitutorfrente"
												custom
												data-browse="Buscar"
												accept=".jpg,.png"
												ref={register}
											/>
											<FontAwesomeIcon icon={faUpload} />
											<label className="ml-2 mb-0">Cargar</label>
										</div>
									</div>
									<span
										id="imgdnitutorfrente-name"
										className="mt-2"
										style={{ color: "#92ADC5" }}
									></span>
								</Col>
								<Col className="mb-sm-3 d-flex flex-column">
									{/* <Form.File
										id='imgdnitutordorso'
										name='imgdnitutordorso'
										label='IMÁGEN DNI TUTOR DORSO'
										custom
										data-browse='Buscar'
										accept='.jpg,.png'
										ref={register}
									/> */}
									<div className="d-flex align-items-center">
										<Form.Label className="mr-3 mb-0">Dorso</Form.Label>
										<div className="file-upload">
											<input
												className="file"
												type="file"
												onChange={uploadFile}
												id="imgdnitutordorso"
												name="imgdnitutordorso"
												custom
												data-browse="Buscar"
												accept=".jpg,.png"
												ref={register}
											/>
											<FontAwesomeIcon icon={faUpload} />
											<label className="ml-2 mb-0">Cargar</label>
										</div>
									</div>
									<span
										id="imgdnitutordorso-name"
										className="mt-2"
										style={{ color: "#92ADC5" }}
									></span>
								</Col>
							</Row>
						</Form.Group>
						<Form.Group>
							<Col className="d-flex pl-0 justify-content-start align-items-center">
								<Form.Check
									type="checkbox"
									id="VERACIDAD"
									label="Acepto la veracidad de la información brindada"
									name="veracidad"
									defaultChecked={false}
									ref={register}
								/>
							</Col>
						</Form.Group>
					</Card.Body>
					<Card.Footer>
						<Row>
							<Col className="d-flex justify-content-start">
								<Button variant="primary" type="submit">
									ENVIAR
								</Button>
							</Col>
						</Row>
					</Card.Footer>
				</Card>
			</Form>
		</div>
	);
};
